export default function (value, count) {
    switch (value) {
        case 'day':
            return count > 1 ? `every ${count} days` : 'daily';
        case 'week':
            return count > 1 ? `every ${count} weeks` : 'weekly';
        case 'month':
            return count > 1 ? `every ${count} months` : 'monthly';
        case 'year':
            return count > 1 ? `every ${count} years` : 'yearly';
    }
}
